import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { QuestionsSection } from './components/QuestionsSection';
import { ChaptersSection } from './components/ChaptersSection';
import { BonusesSection } from './components/BonusesSection';
import { AudienceSection } from './components/AudienceSection';
import { ManifestoSection } from './components/ManifestoSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-cream" data-id="element-0" data-mp="2whxabqim5ie4">
      <SiteHeader data-id="element-1" data-mp="28t4j27cxrypu" />
      <main data-id="element-2" data-mp="28sl0cofgp6ar">
        <Hero data-id="element-3" data-mp="28s2zfehuu3wi" />
        <QuestionsSection data-id="element-4" data-mp="23vkw8j26adma" />
        <ChaptersSection data-id="element-5" data-mp="23u9t8lgjx9w8" />
        <BonusesSection data-id="element-6" data-mp="23ut97wmn5o7m" />
        <AudienceSection data-id="element-7" data-mp="23ti7018ugoim" />
        <ManifestoSection data-id="element-8" data-mp="3ikh829m9asyz" />
        <HowItWorksSection data-id="element-9" data-mp="3ij64a9st9l7v" />
        <OfferSection data-id="element-10" data-mp="3ihv2gfixenje" />
        <FaqSection data-id="element-11" data-mp="3mlj8uuvtnd32" />
      </main>
      <SiteFooter data-id="element-12" data-mp="3mkhmhu9cv461" />
      <PurchaseNotification data-id="element-13" data-mp="3mjzrt22ccy08" />
    </div>;
}